/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from './types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type LegacyProductRecentlyViewedQueryVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
}>;


export type LegacyProductRecentlyViewedQuery = { __typename?: 'Query', legacyProductsFetchProduct?: { __typename?: 'LegacyProduct', id: number, title: string, image?: string | null, regularPrice: number, salePrice: number, favoriteCount: number, slug: string, author: { __typename?: 'LegacyAuthor', name?: string | null }, productMainCategory?: { __typename?: 'LegacyCategory', id: number, title: string, slug: string } | null } | null };

export type TrendingNowPpeProductsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  categories?: Types.InputMaybe<Array<Types.Category> | Types.Category>;
}>;


export type TrendingNowPpeProductsQuery = { __typename?: 'Query', legacyProductsListPPEProducts: { __typename?: 'LegacyPPEResponse', products: Array<{ __typename?: 'LegacyProduct', id: number, title: string, image?: string | null, regularPrice: number, salePrice: number, favoriteCount: number, slug: string, author: { __typename?: 'LegacyAuthor', name?: string | null }, productMainCategory?: { __typename?: 'LegacyCategory', id: number, title: string, slug: string } | null }>, meta: { __typename?: 'LegacyPPEMeta', total: number, nextOffset: number } } };

export type LegacyProductQueryVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
}>;


export type LegacyProductQuery = { __typename?: 'Query', legacyProductsFetchProduct?: { __typename?: 'LegacyProduct', id: number, title: string, description: string, image?: string | null, thumbnail?: Array<string> | null, thumbnailGallery?: Array<string> | null, rating: number, favoriteCount: number, reviewCount: number, slug: string, tags: Array<{ __typename?: 'Tag', id: number, name: string, slug: string }>, productMainCategory?: { __typename?: 'LegacyCategory', id: number, title: string, slug: string } | null } | null };

export type LegacyProductsFetchLicenseQueryVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
}>;


export type LegacyProductsFetchLicenseQuery = { __typename?: 'Query', legacyProductsFetchLicense?: { __typename?: 'LegacyLicense', ID: number } | null };

export type ListMyClassesQueryVariables = Types.Exact<{
  input: Types.ListMyClassesInput;
}>;


export type ListMyClassesQuery = { __typename?: 'Query', listMyClasses: { __typename?: 'ListMyClassesResponse', itemsPerPage: number, totalItems: number, classes?: Array<{ __typename?: 'Class', productId: string, imgSrc: string, imgAlt: string, favorite: boolean, favoriteCount: number, communityProduct: boolean, pinterestUrl: string, studentsEnrolledCount: number, videoLength: string, url: string, category: string, categoryUrl: string, level?: string | null, sourceCfOriginal?: boolean | null }> | null } };

export type GetMyAccountUserProfileQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyAccountUserProfileQuery = { __typename?: 'Query', getMyAccountUserProfile: { __typename?: 'GetMyAccountUserProfileResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null, profile?: { __typename?: 'MyAccountUserProfile', userId: number, avatarUrl: string, profileUrl: string, avatarNonce: string, firstName: string, lastName: string, userGender: Types.Gender, dateOfBirth: string, userCountry: string, userEtsyShop: string, userSuperSkill: string, userBio: string, userMachines?: Array<string> | null, countries: Array<{ __typename?: 'KeyValuePairs', key: string, value: string }>, machines: Array<{ __typename?: 'Machine', id: string, brand: string, name: string }>, interests: Array<{ __typename?: 'KeyValuePairs', key: string, value: string }>, userInterests?: Array<{ __typename?: 'KeyValuePairs', key: string, value: string }> | null, craftings: Array<{ __typename?: 'KeyValuePairs', key: string, value: string }>, userCraftings?: Array<{ __typename?: 'KeyValuePairs', key: string, value: string }> | null, userSocialMediaAccounts: { __typename?: 'SocialMediaAccounts', behance: string, facebook: string, dribbble: string, instagram: string, twitter: string, pinterest: string, youtube: string, tiktok: string } } | null } };

export type GetMyAccountBillingDetailsQueryVariables = Types.Exact<{
  country?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMyAccountBillingDetailsQuery = { __typename?: 'Query', getMyAccountBillingDetails: { __typename?: 'GetMyAccountBillingDetailsResponse', stripePortalUrl: string, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type ListMyAccountDownloadsLicKeysQueryVariables = Types.Exact<{
  input: Types.ListMyAccountDownloadsLicKeysInput;
}>;


export type ListMyAccountDownloadsLicKeysQuery = { __typename?: 'Query', listMyAccountDownloadsLicKeys: { __typename?: 'ListMyAccountDownloadsLicKeysResponse', keysAreBeingGenerated: boolean, hasLicenseKeyDownloadAccess: boolean, exportLicenseKeysNonce: string, itemsPerPage: number, totalPages: number, totalItems: number, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null, downloads?: Array<{ __typename?: 'MyAccountDownload', productId: string, productUrl: string, title: string, thumbnail: string, categoryTag: string, licenseKey: string, licenseUsageCount: string, links?: Array<{ __typename?: 'MyAccountDownloadLink', type: Types.MyAccountDownloadLinkType, url: string, title: string } | null> | null } | null> | null } };

export type GetMyAccountEditEmailPasswordContextQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyAccountEditEmailPasswordContextQuery = { __typename?: 'Query', getMyAccountEditEmailPasswordContext: { __typename?: 'GetMyAccountEditEmailPasswordContextResponse', hasLinkedAccount: boolean, socialAccountsUrl: string, userEmail: string, nonce: string, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null, context?: any | null } | null } };

export type EditMyAccountEmailPasswordMutationVariables = Types.Exact<{
  input: Types.EditMyAccountEmailPasswordInput;
}>;


export type EditMyAccountEmailPasswordMutation = { __typename?: 'Mutation', editMyAccountEmailPassword: { __typename?: 'EditMyAccountEmailPasswordResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type ResetMyAccountEmailMutationVariables = Types.Exact<{
  input: Types.ResetMyAccountEmailInput;
}>;


export type ResetMyAccountEmailMutation = { __typename?: 'Mutation', resetMyAccountEmail: { __typename?: 'ResetMyAccountEmailResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type ConfirmMyAccountEmailResetMutationVariables = Types.Exact<{
  input: Types.ConfirmMyAccountEmailResetInput;
}>;


export type ConfirmMyAccountEmailResetMutation = { __typename?: 'Mutation', confirmMyAccountEmailReset: { __typename?: 'ConfirmMyAccountEmailResetResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type PostAProjectCoinsSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PostAProjectCoinsSettingsQuery = { __typename?: 'Query', coins: { __typename?: 'CoinWallet', errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null, availableRewards: { __typename?: 'CoinAvailableRewards', projectPosts?: number | null } }, coinsSettings: { __typename?: 'CoinSettings', rewards?: { __typename?: 'CoinRewardsSettings', postSocialProductProject: number } | null, spending?: { __typename?: 'CoinSpendingSettings', products: { __typename?: 'CoinSpendingProductsSettings', crafts: number, classes: number, bundles: number } } | null } };

export type PostAProjectCoinsBalanceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PostAProjectCoinsBalanceQuery = { __typename?: 'Query', coins: { __typename?: 'CoinWallet', balance: number, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ListDailyGiftsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListDailyGiftsQuery = { __typename?: 'Query', listDailyGifts: { __typename?: 'ListDailyGiftsResponse', freeBundleUrl: string, freeBundleId: number, facebookShareUrl: string, dailyGifts: Array<{ __typename?: 'DailyGifts', categoryId: string, title: string, url: string, total: number, freeProduct?: { __typename?: 'DailyGiftsFreeProduct', id: number, title: string, imageUrl: string, shopName: string, shopUrl: string, expiresAt: string, price: number, priceCurrency: string, downloadLink: string } | null, promoProducts?: Array<{ __typename?: 'DailyGiftsPromoProduct', id: number, title: string, url: string, imageUrl: string, priceFull: number, priceDiscount?: number | null, priceCurrency: string, titleTop: string, shopName: string, shopUrl: string, expiresAt: string, isDeal?: boolean | null }> | null }>, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };


export const EditMyAccountEmailPasswordDocument = `
mutation EditMyAccountEmailPassword($input: EditMyAccountEmailPasswordInput!) {
  editMyAccountEmailPassword(input: $input) {
    error {
      type
      description
    }
  }
}

`

export const EditMyAccountEmailPasswordMutationKey = 'EditMyAccountEmailPassword'

export function EditMyAccountEmailPasswordMutationFetcher(variables: EditMyAccountEmailPasswordMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<EditMyAccountEmailPasswordMutation, EditMyAccountEmailPasswordMutationVariables>(EditMyAccountEmailPasswordDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useEditMyAccountEmailPasswordMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<EditMyAccountEmailPasswordMutation, E, EditMyAccountEmailPasswordMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<EditMyAccountEmailPasswordMutation, E, EditMyAccountEmailPasswordMutationVariables, C>({
        ...options,
        mutationKey: [EditMyAccountEmailPasswordMutationKey],
        mutationFn: (variables: EditMyAccountEmailPasswordMutationVariables) => EditMyAccountEmailPasswordMutationFetcher(variables, fetchOptions),
    })
}

export const ResetMyAccountEmailDocument = `
mutation resetMyAccountEmail($input: ResetMyAccountEmailInput!) {
  resetMyAccountEmail(input: $input) {
    error {
      type
      description
    }
  }
}

`

export const resetMyAccountEmailMutationKey = 'resetMyAccountEmail'

export function resetMyAccountEmailMutationFetcher(variables: ResetMyAccountEmailMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ResetMyAccountEmailMutation, ResetMyAccountEmailMutationVariables>(ResetMyAccountEmailDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useResetMyAccountEmailMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ResetMyAccountEmailMutation, E, ResetMyAccountEmailMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ResetMyAccountEmailMutation, E, ResetMyAccountEmailMutationVariables, C>({
        ...options,
        mutationKey: [resetMyAccountEmailMutationKey],
        mutationFn: (variables: ResetMyAccountEmailMutationVariables) => resetMyAccountEmailMutationFetcher(variables, fetchOptions),
    })
}

export const ConfirmMyAccountEmailResetDocument = `
mutation confirmMyAccountEmailReset($input: ConfirmMyAccountEmailResetInput!) {
  confirmMyAccountEmailReset(input: $input) {
    error {
      type
      description
    }
  }
}

`

export const confirmMyAccountEmailResetMutationKey = 'confirmMyAccountEmailReset'

export function confirmMyAccountEmailResetMutationFetcher(variables: ConfirmMyAccountEmailResetMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ConfirmMyAccountEmailResetMutation, ConfirmMyAccountEmailResetMutationVariables>(ConfirmMyAccountEmailResetDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useConfirmMyAccountEmailResetMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ConfirmMyAccountEmailResetMutation, E, ConfirmMyAccountEmailResetMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ConfirmMyAccountEmailResetMutation, E, ConfirmMyAccountEmailResetMutationVariables, C>({
        ...options,
        mutationKey: [confirmMyAccountEmailResetMutationKey],
        mutationFn: (variables: ConfirmMyAccountEmailResetMutationVariables) => confirmMyAccountEmailResetMutationFetcher(variables, fetchOptions),
    })
}

export const LegacyProductRecentlyViewedDocument = `
query legacyProductRecentlyViewed($productId: Int!) {
  legacyProductsFetchProduct(id: $productId) {
    id
    title
    image
    author {
      name
    }
    regularPrice
    salePrice
    favoriteCount
    slug
    productMainCategory {
      id
      title
      slug
    }
  }
}

`

export const legacyProductRecentlyViewedQueryRootKey = 'legacyProductRecentlyViewed'

export function legacyProductRecentlyViewedQueryFetcher(variables: LegacyProductRecentlyViewedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<LegacyProductRecentlyViewedQuery, LegacyProductRecentlyViewedQueryVariables>(LegacyProductRecentlyViewedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function legacyProductRecentlyViewedQueryKey(variables: LegacyProductRecentlyViewedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [legacyProductRecentlyViewedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function legacyProductRecentlyViewedQueryOptions(
    variables: LegacyProductRecentlyViewedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<LegacyProductRecentlyViewedQuery, unknown, LegacyProductRecentlyViewedQuery, (LegacyProductRecentlyViewedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: legacyProductRecentlyViewedQueryKey(variables, fetchOptions),
        queryFn: legacyProductRecentlyViewedQueryFetcher(variables, fetchOptions),
    }
}

export function useLegacyProductRecentlyViewedQuery<D = LegacyProductRecentlyViewedQuery, E = unknown>(
    variables: LegacyProductRecentlyViewedQueryVariables,
    options?: Omit<UseQueryOptions<LegacyProductRecentlyViewedQuery, E, D, (LegacyProductRecentlyViewedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<LegacyProductRecentlyViewedQuery, E, D, (LegacyProductRecentlyViewedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...legacyProductRecentlyViewedQueryOptions(variables, fetchOptions),
    })
}

export const TrendingNowPpeProductsDocument = `
query trendingNowPPEProducts($limit: Int!, $offset: Int, $categories: [Category!]) {
  legacyProductsListPPEProducts(
    input: {limit: $limit, offset: $offset, categories: $categories}
  ) {
    products {
      id
      title
      image
      author {
        name
      }
      regularPrice
      salePrice
      favoriteCount
      slug
      productMainCategory {
        id
        title
        slug
      }
    }
    meta {
      total
      nextOffset
    }
  }
}

`

export const trendingNowPPEProductsQueryRootKey = 'trendingNowPPEProducts'

export function trendingNowPPEProductsQueryFetcher(variables: TrendingNowPpeProductsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<TrendingNowPpeProductsQuery, TrendingNowPpeProductsQueryVariables>(TrendingNowPpeProductsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function trendingNowPPEProductsQueryKey(variables: TrendingNowPpeProductsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [trendingNowPPEProductsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function trendingNowPPEProductsQueryOptions(
    variables: TrendingNowPpeProductsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<TrendingNowPpeProductsQuery, unknown, TrendingNowPpeProductsQuery, (TrendingNowPpeProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: trendingNowPPEProductsQueryKey(variables, fetchOptions),
        queryFn: trendingNowPPEProductsQueryFetcher(variables, fetchOptions),
    }
}

export function useTrendingNowPpeProductsQuery<D = TrendingNowPpeProductsQuery, E = unknown>(
    variables: TrendingNowPpeProductsQueryVariables,
    options?: Omit<UseQueryOptions<TrendingNowPpeProductsQuery, E, D, (TrendingNowPpeProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<TrendingNowPpeProductsQuery, E, D, (TrendingNowPpeProductsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...trendingNowPPEProductsQueryOptions(variables, fetchOptions),
    })
}

export const LegacyProductDocument = `
query legacyProduct($productId: Int!) {
  legacyProductsFetchProduct(id: $productId) {
    id
    title
    description
    image
    thumbnail
    thumbnailGallery
    tags {
      id
      name
      slug
    }
    rating
    favoriteCount
    reviewCount
    thumbnail
    slug
    productMainCategory {
      id
      title
      slug
    }
  }
}

`

export const legacyProductQueryRootKey = 'legacyProduct'

export function legacyProductQueryFetcher(variables: LegacyProductQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<LegacyProductQuery, LegacyProductQueryVariables>(LegacyProductDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function legacyProductQueryKey(variables: LegacyProductQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [legacyProductQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function legacyProductQueryOptions(
    variables: LegacyProductQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<LegacyProductQuery, unknown, LegacyProductQuery, (LegacyProductQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: legacyProductQueryKey(variables, fetchOptions),
        queryFn: legacyProductQueryFetcher(variables, fetchOptions),
    }
}

export function useLegacyProductQuery<D = LegacyProductQuery, E = unknown>(
    variables: LegacyProductQueryVariables,
    options?: Omit<UseQueryOptions<LegacyProductQuery, E, D, (LegacyProductQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<LegacyProductQuery, E, D, (LegacyProductQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...legacyProductQueryOptions(variables, fetchOptions),
    })
}

export const LegacyProductsFetchLicenseDocument = `
query legacyProductsFetchLicense($productId: Int!) {
  legacyProductsFetchLicense(productId: $productId) {
    ID
  }
}

`

export const legacyProductsFetchLicenseQueryRootKey = 'legacyProductsFetchLicense'

export function legacyProductsFetchLicenseQueryFetcher(variables: LegacyProductsFetchLicenseQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<LegacyProductsFetchLicenseQuery, LegacyProductsFetchLicenseQueryVariables>(LegacyProductsFetchLicenseDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function legacyProductsFetchLicenseQueryKey(variables: LegacyProductsFetchLicenseQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [legacyProductsFetchLicenseQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function legacyProductsFetchLicenseQueryOptions(
    variables: LegacyProductsFetchLicenseQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<LegacyProductsFetchLicenseQuery, unknown, LegacyProductsFetchLicenseQuery, (LegacyProductsFetchLicenseQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: legacyProductsFetchLicenseQueryKey(variables, fetchOptions),
        queryFn: legacyProductsFetchLicenseQueryFetcher(variables, fetchOptions),
    }
}

export function useLegacyProductsFetchLicenseQuery<D = LegacyProductsFetchLicenseQuery, E = unknown>(
    variables: LegacyProductsFetchLicenseQueryVariables,
    options?: Omit<UseQueryOptions<LegacyProductsFetchLicenseQuery, E, D, (LegacyProductsFetchLicenseQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<LegacyProductsFetchLicenseQuery, E, D, (LegacyProductsFetchLicenseQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...legacyProductsFetchLicenseQueryOptions(variables, fetchOptions),
    })
}

export const ListMyClassesDocument = `
query listMyClasses($input: ListMyClassesInput!) {
  listMyClasses(input: $input) {
    classes {
      productId
      imgSrc
      imgAlt
      favorite
      favoriteCount
      communityProduct
      pinterestUrl
      studentsEnrolledCount
      videoLength
      url
      category
      categoryUrl
      level
      sourceCfOriginal
    }
    itemsPerPage
    totalItems
  }
}

`

export const listMyClassesQueryRootKey = 'listMyClasses'

export function listMyClassesQueryFetcher(variables: ListMyClassesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ListMyClassesQuery, ListMyClassesQueryVariables>(ListMyClassesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function listMyClassesQueryKey(variables: ListMyClassesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [listMyClassesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function listMyClassesQueryOptions(
    variables: ListMyClassesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ListMyClassesQuery, unknown, ListMyClassesQuery, (ListMyClassesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: listMyClassesQueryKey(variables, fetchOptions),
        queryFn: listMyClassesQueryFetcher(variables, fetchOptions),
    }
}

export function useListMyClassesQuery<D = ListMyClassesQuery, E = unknown>(
    variables: ListMyClassesQueryVariables,
    options?: Omit<UseQueryOptions<ListMyClassesQuery, E, D, (ListMyClassesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ListMyClassesQuery, E, D, (ListMyClassesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...listMyClassesQueryOptions(variables, fetchOptions),
    })
}

export const GetMyAccountUserProfileDocument = `
query GetMyAccountUserProfile {
  getMyAccountUserProfile {
    error {
      type
      description
    }
    profile {
      userId
      avatarUrl
      profileUrl
      avatarNonce
      firstName
      lastName
      userGender
      dateOfBirth
      countries {
        key
        value
      }
      userCountry
      userEtsyShop
      userSuperSkill
      userBio
      machines {
        id
        brand
        name
      }
      userMachines
      interests {
        key
        value
      }
      userInterests {
        key
        value
      }
      craftings {
        key
        value
      }
      userCraftings {
        key
        value
      }
      userSocialMediaAccounts {
        behance
        facebook
        dribbble
        instagram
        twitter
        pinterest
        youtube
        tiktok
      }
    }
  }
}

`

export const GetMyAccountUserProfileQueryRootKey = 'GetMyAccountUserProfile'

export function GetMyAccountUserProfileQueryFetcher(variables?: GetMyAccountUserProfileQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<GetMyAccountUserProfileQuery, GetMyAccountUserProfileQueryVariables>(GetMyAccountUserProfileDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function GetMyAccountUserProfileQueryKey(variables?: GetMyAccountUserProfileQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [GetMyAccountUserProfileQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function GetMyAccountUserProfileQueryOptions(
    variables?: GetMyAccountUserProfileQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<GetMyAccountUserProfileQuery, unknown, GetMyAccountUserProfileQuery, (GetMyAccountUserProfileQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: GetMyAccountUserProfileQueryKey(variables, fetchOptions),
        queryFn: GetMyAccountUserProfileQueryFetcher(variables, fetchOptions),
    }
}

export function useGetMyAccountUserProfileQuery<D = GetMyAccountUserProfileQuery, E = unknown>(
    variables?: GetMyAccountUserProfileQueryVariables,
    options?: Omit<UseQueryOptions<GetMyAccountUserProfileQuery, E, D, (GetMyAccountUserProfileQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<GetMyAccountUserProfileQuery, E, D, (GetMyAccountUserProfileQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...GetMyAccountUserProfileQueryOptions(variables, fetchOptions),
    })
}

export const GetMyAccountBillingDetailsDocument = `
query GetMyAccountBillingDetails($country: String) {
  getMyAccountBillingDetails(country: $country) {
    error {
      type
      description
    }
    stripePortalUrl
  }
}

`

export const GetMyAccountBillingDetailsQueryRootKey = 'GetMyAccountBillingDetails'

export function GetMyAccountBillingDetailsQueryFetcher(variables?: GetMyAccountBillingDetailsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<GetMyAccountBillingDetailsQuery, GetMyAccountBillingDetailsQueryVariables>(GetMyAccountBillingDetailsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function GetMyAccountBillingDetailsQueryKey(variables?: GetMyAccountBillingDetailsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [GetMyAccountBillingDetailsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function GetMyAccountBillingDetailsQueryOptions(
    variables?: GetMyAccountBillingDetailsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<GetMyAccountBillingDetailsQuery, unknown, GetMyAccountBillingDetailsQuery, (GetMyAccountBillingDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: GetMyAccountBillingDetailsQueryKey(variables, fetchOptions),
        queryFn: GetMyAccountBillingDetailsQueryFetcher(variables, fetchOptions),
    }
}

export function useGetMyAccountBillingDetailsQuery<D = GetMyAccountBillingDetailsQuery, E = unknown>(
    variables?: GetMyAccountBillingDetailsQueryVariables,
    options?: Omit<UseQueryOptions<GetMyAccountBillingDetailsQuery, E, D, (GetMyAccountBillingDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<GetMyAccountBillingDetailsQuery, E, D, (GetMyAccountBillingDetailsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...GetMyAccountBillingDetailsQueryOptions(variables, fetchOptions),
    })
}

export const ListMyAccountDownloadsLicKeysDocument = `
query ListMyAccountDownloadsLicKeys($input: ListMyAccountDownloadsLicKeysInput!) {
  listMyAccountDownloadsLicKeys(input: $input) {
    error {
      type
      description
    }
    downloads {
      productId
      productUrl
      title
      thumbnail
      categoryTag
      links {
        type
        url
        title
      }
      licenseKey
      licenseUsageCount
    }
    keysAreBeingGenerated
    hasLicenseKeyDownloadAccess
    exportLicenseKeysNonce
    itemsPerPage
    totalPages
    totalItems
  }
}

`

export const ListMyAccountDownloadsLicKeysQueryRootKey = 'ListMyAccountDownloadsLicKeys'

export function ListMyAccountDownloadsLicKeysQueryFetcher(variables: ListMyAccountDownloadsLicKeysQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ListMyAccountDownloadsLicKeysQuery, ListMyAccountDownloadsLicKeysQueryVariables>(ListMyAccountDownloadsLicKeysDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ListMyAccountDownloadsLicKeysQueryKey(variables: ListMyAccountDownloadsLicKeysQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ListMyAccountDownloadsLicKeysQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function ListMyAccountDownloadsLicKeysQueryOptions(
    variables: ListMyAccountDownloadsLicKeysQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ListMyAccountDownloadsLicKeysQuery, unknown, ListMyAccountDownloadsLicKeysQuery, (ListMyAccountDownloadsLicKeysQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ListMyAccountDownloadsLicKeysQueryKey(variables, fetchOptions),
        queryFn: ListMyAccountDownloadsLicKeysQueryFetcher(variables, fetchOptions),
    }
}

export function useListMyAccountDownloadsLicKeysQuery<D = ListMyAccountDownloadsLicKeysQuery, E = unknown>(
    variables: ListMyAccountDownloadsLicKeysQueryVariables,
    options?: Omit<UseQueryOptions<ListMyAccountDownloadsLicKeysQuery, E, D, (ListMyAccountDownloadsLicKeysQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ListMyAccountDownloadsLicKeysQuery, E, D, (ListMyAccountDownloadsLicKeysQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ListMyAccountDownloadsLicKeysQueryOptions(variables, fetchOptions),
    })
}

export const GetMyAccountEditEmailPasswordContextDocument = `
query GetMyAccountEditEmailPasswordContext {
  getMyAccountEditEmailPasswordContext {
    error {
      type
      description
      context
    }
    hasLinkedAccount
    socialAccountsUrl
    userEmail
    nonce
  }
}

`

export const GetMyAccountEditEmailPasswordContextQueryRootKey = 'GetMyAccountEditEmailPasswordContext'

export function GetMyAccountEditEmailPasswordContextQueryFetcher(variables?: GetMyAccountEditEmailPasswordContextQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<GetMyAccountEditEmailPasswordContextQuery, GetMyAccountEditEmailPasswordContextQueryVariables>(GetMyAccountEditEmailPasswordContextDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function GetMyAccountEditEmailPasswordContextQueryKey(variables?: GetMyAccountEditEmailPasswordContextQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [GetMyAccountEditEmailPasswordContextQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function GetMyAccountEditEmailPasswordContextQueryOptions(
    variables?: GetMyAccountEditEmailPasswordContextQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<GetMyAccountEditEmailPasswordContextQuery, unknown, GetMyAccountEditEmailPasswordContextQuery, (GetMyAccountEditEmailPasswordContextQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: GetMyAccountEditEmailPasswordContextQueryKey(variables, fetchOptions),
        queryFn: GetMyAccountEditEmailPasswordContextQueryFetcher(variables, fetchOptions),
    }
}

export function useGetMyAccountEditEmailPasswordContextQuery<D = GetMyAccountEditEmailPasswordContextQuery, E = unknown>(
    variables?: GetMyAccountEditEmailPasswordContextQueryVariables,
    options?: Omit<UseQueryOptions<GetMyAccountEditEmailPasswordContextQuery, E, D, (GetMyAccountEditEmailPasswordContextQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<GetMyAccountEditEmailPasswordContextQuery, E, D, (GetMyAccountEditEmailPasswordContextQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...GetMyAccountEditEmailPasswordContextQueryOptions(variables, fetchOptions),
    })
}

export const PostAProjectCoinsSettingsDocument = `
query PostAProjectCoinsSettings {
  coins {
    errors {
      code
      message
    }
    availableRewards {
      projectPosts
    }
  }
  coinsSettings {
    rewards {
      postSocialProductProject
    }
    spending {
      products {
        crafts
        classes
        bundles
      }
    }
  }
}

`

export const PostAProjectCoinsSettingsQueryRootKey = 'PostAProjectCoinsSettings'

export function PostAProjectCoinsSettingsQueryFetcher(variables?: PostAProjectCoinsSettingsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<PostAProjectCoinsSettingsQuery, PostAProjectCoinsSettingsQueryVariables>(PostAProjectCoinsSettingsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function PostAProjectCoinsSettingsQueryKey(variables?: PostAProjectCoinsSettingsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [PostAProjectCoinsSettingsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function PostAProjectCoinsSettingsQueryOptions(
    variables?: PostAProjectCoinsSettingsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<PostAProjectCoinsSettingsQuery, unknown, PostAProjectCoinsSettingsQuery, (PostAProjectCoinsSettingsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: PostAProjectCoinsSettingsQueryKey(variables, fetchOptions),
        queryFn: PostAProjectCoinsSettingsQueryFetcher(variables, fetchOptions),
    }
}

export function usePostAProjectCoinsSettingsQuery<D = PostAProjectCoinsSettingsQuery, E = unknown>(
    variables?: PostAProjectCoinsSettingsQueryVariables,
    options?: Omit<UseQueryOptions<PostAProjectCoinsSettingsQuery, E, D, (PostAProjectCoinsSettingsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<PostAProjectCoinsSettingsQuery, E, D, (PostAProjectCoinsSettingsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...PostAProjectCoinsSettingsQueryOptions(variables, fetchOptions),
    })
}

export const PostAProjectCoinsBalanceDocument = `
query PostAProjectCoinsBalance {
  coins {
    errors {
      code
      message
    }
    balance
  }
}

`

export const PostAProjectCoinsBalanceQueryRootKey = 'PostAProjectCoinsBalance'

export function PostAProjectCoinsBalanceQueryFetcher(variables?: PostAProjectCoinsBalanceQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<PostAProjectCoinsBalanceQuery, PostAProjectCoinsBalanceQueryVariables>(PostAProjectCoinsBalanceDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function PostAProjectCoinsBalanceQueryKey(variables?: PostAProjectCoinsBalanceQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [PostAProjectCoinsBalanceQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function PostAProjectCoinsBalanceQueryOptions(
    variables?: PostAProjectCoinsBalanceQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<PostAProjectCoinsBalanceQuery, unknown, PostAProjectCoinsBalanceQuery, (PostAProjectCoinsBalanceQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: PostAProjectCoinsBalanceQueryKey(variables, fetchOptions),
        queryFn: PostAProjectCoinsBalanceQueryFetcher(variables, fetchOptions),
    }
}

export function usePostAProjectCoinsBalanceQuery<D = PostAProjectCoinsBalanceQuery, E = unknown>(
    variables?: PostAProjectCoinsBalanceQueryVariables,
    options?: Omit<UseQueryOptions<PostAProjectCoinsBalanceQuery, E, D, (PostAProjectCoinsBalanceQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<PostAProjectCoinsBalanceQuery, E, D, (PostAProjectCoinsBalanceQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...PostAProjectCoinsBalanceQueryOptions(variables, fetchOptions),
    })
}

export const ListDailyGiftsDocument = `
query listDailyGifts {
  listDailyGifts {
    dailyGifts {
      categoryId
      title
      url
      total
      freeProduct {
        id
        title
        imageUrl
        shopName
        shopUrl
        expiresAt
        price
        priceCurrency
        downloadLink
      }
      promoProducts {
        id
        title
        url
        imageUrl
        priceFull
        priceDiscount
        priceCurrency
        titleTop
        shopName
        shopUrl
        expiresAt
        isDeal
      }
    }
    freeBundleUrl
    freeBundleId
    facebookShareUrl
    error {
      type
      description
    }
  }
}

`

export const listDailyGiftsQueryRootKey = 'listDailyGifts'

export function listDailyGiftsQueryFetcher(variables?: ListDailyGiftsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ListDailyGiftsQuery, ListDailyGiftsQueryVariables>(ListDailyGiftsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function listDailyGiftsQueryKey(variables?: ListDailyGiftsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [listDailyGiftsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function listDailyGiftsQueryOptions(
    variables?: ListDailyGiftsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ListDailyGiftsQuery, unknown, ListDailyGiftsQuery, (ListDailyGiftsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: listDailyGiftsQueryKey(variables, fetchOptions),
        queryFn: listDailyGiftsQueryFetcher(variables, fetchOptions),
    }
}

export function useListDailyGiftsQuery<D = ListDailyGiftsQuery, E = unknown>(
    variables?: ListDailyGiftsQueryVariables,
    options?: Omit<UseQueryOptions<ListDailyGiftsQuery, E, D, (ListDailyGiftsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ListDailyGiftsQuery, E, D, (ListDailyGiftsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...listDailyGiftsQueryOptions(variables, fetchOptions),
    })
}